import { render } from "./SlidingUrl.vue?vue&type=template&id=cf2bbdee&scoped=true"
import script from "./SlidingUrl.vue?vue&type=script&lang=js"
export * from "./SlidingUrl.vue?vue&type=script&lang=js"

import "./SlidingUrl.vue?vue&type=style&index=0&id=cf2bbdee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf2bbdee"]])

export default __exports__